// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"404":"3b246e9b","797":"3b246e9b"}[chunkId] + ".chunk.css";
};